export interface TargetProfession {
  title: string;
  description?: string;
}

export const targetProfessions: TargetProfession[] = [
  {
    title: "Financial Advisors & Wealth Managers"
  },
  {
    title: "Realtors"
  },
  {
    title: "Reverse-Mortgage & HELOC Specialists"
  },
  {
    title: "Insurance Agents (Home, Life, Health)"
  },
  {
    title: "Elder Law & Estate Planning Attorneys"
  },
  {
    title: "Occupational Therapists & Home-Mod Professionals"
  }
];